
/**
 * main Data 관리 클래스
 * @category main
 * @memberof module:main
 * @param  {Object} _config={} 설정
 */
class DataStore {
    constructor(_config={}){
        this.data = {
            config: _config,
            Hotkeyword: _config.liveKeywords
        };

        this.apiUrlList = {
            // 개별 콘티 => 사용 안함
            mainNotices: this.data.config.apiDomain + '/conti/getContent?service=lineage2&alias=main-news',
            mainGMcontents: this.data.config.apiDomain + '/conti/getContent?service=lineage2&alias=main-gmcontents',
            mainCardlist1: this.data.config.apiDomain + '/conti/getContent?service=lineage2&alias=main-section1',
            mainCardlist2: this.data.config.apiDomain + '/conti/getContent?service=lineage2&alias=main-section2',
            mainCardlist3: this.data.config.apiDomain + '/conti/getContent?service=lineage2&alias=main-section3',
            mainCardlist4: this.data.config.apiDomain + '/conti/getContent?service=lineage2&alias=main-section4',
            mainBanner: this.data.config.apiDomain + '/conti/getContent?service=lineage2&alias=main-promotion',
            serverIntegration: this.data.config.apiDomain +'/conti/getContent?service=lineage2&alias=main-server-integration',
            
            // 콘티 그룹 => 사용
            mainContentGroup: this.data.config.apiDomain + '/conti/getContentGroup?service=lineage2&groupAlias=lineage2-main-contents&subAlias=ko-KR',

            // 유저 신규&복귀 배너에서 사용하는 유저 정보 (신규인지 복귀인지)
            StateBanner: this.data.config.apiDomain + '/user/state',
            // 메인에 캐릭터 정보 보여주는 영역
            CharacterInfo: this.data.config.apiDomain + '/main/character',
            // 서버통합 배너에서 사용하는, 현재 로그인한 유저의 서버통합 정보 데이터
            serverIntegrationCharactorInfo: this.data.config.apiDomain + '/serverchange/characters'
        };

    }

    /**
     * @param  {String} _key='subsub'  요청할 데이터의 키네임
     * @param  {Object} _param={} 요청시 추가할 파라미터 데이터
     * @param  {Function} _callback=()=>{} 요청 완료후 데이터 전달할 콜백 함수...
     * @category main
     * @returns {Object} Json 데이타
     * @example
     * const appConfig = getData('sub1', {page: 1,per_page: 12}, this.render.bind(this));
     */
    getData(_key = '', _param={}, _callback = ()=>{}){
        if( this.data[_key] ){
            _callback(this.data[_key]);
            return this.data[_key];
        }else{
            axios.get(this.apiUrlList[_key], {
                params: _param,
                withCredentials: true
            })
            .then( (response) => {
                this.data[_key] = response.data;
                _callback(response.data);
                return response.data;
            })
            .catch( (error, d) => {
                console.log(_key, error,'----', d);
            })
            .then( (d) => {
                // console.log( d);
            }); 
        }
    }

    getDataServerIntergrationCharactorInifo(){
        return (axios.get(this.apiUrlList['serverIntegrationCharactorInfo'], {
            withCredentials: true
        })
        .then( (response) => {
            this.data.serverIntegrationCharactorInfo = response.data;
            return response.data;
        })
        .catch( (error, d) => {
            console.log('mainContentGroup', error,'----', d);
        })); 
    }

    getDataContiGroup(mappingAliasToDatakey){
        return (axios.get(this.apiUrlList['mainContentGroup'], {
            withCredentials: true
        })
        .then( (response) => {
            response.data.forEach(content=>{
                const targetAlias = content['alias'];
                this.data[mappingAliasToDatakey[targetAlias]] = content;
            })

            return response.data;
        })
        .catch( (error, d) => {
            console.log('mainContentGroup', error,'----', d);
        })
        .then( (d) => {
            // console.log( d);
        })); 
    }

} // end of class
export default DataStore;



const _temp = [
    {
    "gameUid": 1000068155,
    "fromServerId": 110,
    "fromServerName": "자켄",
    "fromCharacterName": "암살12345",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "자켄12345_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 110,
    "fromServerName": "자켄",
    "fromCharacterName": "암살22222",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "자켄22222_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 110,
    "fromServerName": "자켄",
    "fromCharacterName": "암살33333",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "자켄33333_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 110,
    "fromServerName": "자켄",
    "fromCharacterName": "암살44444",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "자켄44444_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 110,
    "fromServerName": "자켄",
    "fromCharacterName": "암살55555",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "자켄55555_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 110,
    "fromServerName": "자켄",
    "fromCharacterName": "암살666666666",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "자켄666666666_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 110,
    "fromServerName": "자켄",
    "fromCharacterName": "암살7777777777",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "자켄7777777777_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 115,
    "fromServerName": "신화",
    "fromCharacterName": "신화11111111111",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "신화11111111111_115"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 115,
    "fromServerName": "신화",
    "fromCharacterName": "신화222222222222",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "신화22222222222_115"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 115,
    "fromServerName": "신화",
    "fromCharacterName": "신화333333333333",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "신화33333333333_115"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 115,
    "fromServerName": "신화",
    "fromCharacterName": "신화444444444444",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "신화44444444444_115"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 115,
    "fromServerName": "신화",
    "fromCharacterName": "신화555555555555",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "신화55555555555_115"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 115,
    "fromServerName": "신화",
    "fromCharacterName": "신화666666666666",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "신화66666666666_115"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 115,
    "fromServerName": "신화",
    "fromCharacterName": "신화777777777777",
    "toServerId": 73,
    "toServerName": "센티널",
    "toCharacterName": "신화77777777777_115"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 112,
    "fromServerName": "전설",
    "fromCharacterName": "전설111111111111",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "전설11111111111_112"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 112,
    "fromServerName": "전설",
    "fromCharacterName": "전설222222222222",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "전설11111111111_112"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 112,
    "fromServerName": "전설",
    "fromCharacterName": "전설333333333333",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "전설11111111111_112"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 112,
    "fromServerName": "전설",
    "fromCharacterName": "전설444444444444",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "전설11111111111_112"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 112,
    "fromServerName": "전설",
    "fromCharacterName": "전설555555555555",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "전설11111111111_112"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 112,
    "fromServerName": "전설",
    "fromCharacterName": "전설666666666666",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "전설11111111111_112"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 112,
    "fromServerName": "전설",
    "fromCharacterName": "전설777777777777",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "전설11111111111_112"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 100,
    "fromServerName": "오크",
    "fromCharacterName": "오크111111111111",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "오크11111111111_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 100,
    "fromServerName": "오크",
    "fromCharacterName": "오크222222222222",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "오크222222222222_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 100,
    "fromServerName": "오크",
    "fromCharacterName": "오크333333333333",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "오크333333333333_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 100,
    "fromServerName": "오크",
    "fromCharacterName": "오크444444444444",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "오크444444444444_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 100,
    "fromServerName": "오크",
    "fromCharacterName": "오크555555555555",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "오크555555555555_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 100,
    "fromServerName": "오크",
    "fromCharacterName": "오크666666666666",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "오크666666666666_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 100,
    "fromServerName": "오크",
    "fromCharacterName": "오크777777777777",
    "toServerId": 74,
    "toServerName": "헌터",
    "toCharacterName": "오크777777777777_110"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 114,
    "fromServerName": "실프",
    "fromCharacterName": "실프111111111111",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "실프111111111111_114"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 114,
    "fromServerName": "실프",
    "fromCharacterName": "실프222222222222",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "실프222222222222_114"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 114,
    "fromServerName": "실프",
    "fromCharacterName": "실프333333333333",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "실프333333333333_114"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 114,
    "fromServerName": "실프",
    "fromCharacterName": "실프444444444444",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "실프444444444444_114"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 114,
    "fromServerName": "실프",
    "fromCharacterName": "실프555555555555",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "실프555555555555_114"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 114,
    "fromServerName": "실프",
    "fromCharacterName": "실프666666666666",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "실프666666666666_114"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 114,
    "fromServerName": "실프",
    "fromCharacterName": "실프777777777777",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "실프111111111111"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 111,
    "fromServerName": "데스",
    "fromCharacterName": "데스111111111111",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "데스111111111111_111"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 111,
    "fromServerName": "데스",
    "fromCharacterName": "데스222222222222",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "데스222222222222_111"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 111,
    "fromServerName": "데스",
    "fromCharacterName": "데스333333333333",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "데스333333333333_111"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 111,
    "fromServerName": "데스",
    "fromCharacterName": "데스444444444444",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "데스444444444444_111"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 111,
    "fromServerName": "데스",
    "fromCharacterName": "데스555555555555",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "데스555555555555_111"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 111,
    "fromServerName": "데스",
    "fromCharacterName": "데스666666666666",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "데스666666666666_111"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 111,
    "fromServerName": "데스",
    "fromCharacterName": "데스777777777777",
    "toServerId": 75,
    "toServerName": "어비스",
    "toCharacterName": "데스777777777777_111"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 105,
    "fromServerName": "윈드",
    "fromCharacterName": "윈드111111111111",
    "toServerId": 76,
    "toServerName": "피닉스",
    "toCharacterName": "윈드111111111111_105"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 105,
    "fromServerName": "윈드",
    "fromCharacterName": "윈드222222222222",
    "toServerId": 76,
    "toServerName": "피닉스",
    "toCharacterName": "윈드222222222222_105"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 105,
    "fromServerName": "윈드",
    "fromCharacterName": "윈드333333333333",
    "toServerId": 76,
    "toServerName": "피닉스",
    "toCharacterName": "윈드333333333333_105"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 105,
    "fromServerName": "윈드",
    "fromCharacterName": "윈드444444444444",
    "toServerId": 76,
    "toServerName": "피닉스",
    "toCharacterName": "윈드444444444444_105"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 105,
    "fromServerName": "윈드",
    "fromCharacterName": "윈드555555555555",
    "toServerId": 76,
    "toServerName": "피닉스",
    "toCharacterName": "윈드555555555555_105"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 105,
    "fromServerName": "윈드",
    "fromCharacterName": "윈드666666666666",
    "toServerId": 76,
    "toServerName": "피닉스",
    "toCharacterName": "윈드666666666666_105"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 105,
    "fromServerName": "윈드",
    "fromCharacterName": "윈드777777777777",
    "toServerId": 76,
    "toServerName": "피닉스",
    "toCharacterName": "윈드777777777777_105"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 98,
    "fromServerName": "불멸",
    "fromCharacterName": "불멸111111111111",
    "toServerId": 98,
    "toServerName": "불멸",
    "toCharacterName": "불멸111111111111_98"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 98,
    "fromServerName": "불멸",
    "fromCharacterName": "불멸222222222222",
    "toServerId": 98,
    "toServerName": "불멸",
    "toCharacterName": "불멸222222222222_98"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 98,
    "fromServerName": "불멸",
    "fromCharacterName": "불멸333333333333",
    "toServerId": 98,
    "toServerName": "불멸",
    "toCharacterName": "불멸333333333333_98"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 98,
    "fromServerName": "불멸",
    "fromCharacterName": "불멸444444444444",
    "toServerId": 98,
    "toServerName": "불멸",
    "toCharacterName": "불멸444444444444_98"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 98,
    "fromServerName": "불멸",
    "fromCharacterName": "불멸555555555555",
    "toServerId": 98,
    "toServerName": "불멸",
    "toCharacterName": "불멸555555555555_98"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 98,
    "fromServerName": "불멸",
    "fromCharacterName": "불멸666666666666",
    "toServerId": 98,
    "toServerName": "불멸",
    "toCharacterName": "불멸666666666666_98"
    },
    {
    "gameUid": 1000068155,
    "fromServerId": 98,
    "fromServerName": "불멸",
    "fromCharacterName": "불멸777777777777",
    "toServerId": 98,
    "toServerName": "불멸",
    "toCharacterName": "불멸777777777777_98"
    }
]